/** 险种页 + 行业页 FAQ 补充（每页 +2 条，凑满至少 8 条） */
export default {
  directorsOfficers: [
    { q: '非上市公司需要购买董责险吗？', a: '需要。非上市公司同样面临股东诉讼、监管调查、雇佣相关索赔及融资/IPO准备阶段的风险，董责险可保障董事高管个人资产，也是不少投资机构对被投企业的合规要求之一。' },
    { q: '董责险续保或更换经纪人要注意什么？', a: '续保应提前梳理近一年公司治理变化、诉讼/调查记录及融资动态；更换经纪人时可请耀达协助审阅现有保单缺口，并在全球保险人网络中重新比价，避免保障断层。' }
  ],
  mergersAcquisitions: [
    { q: 'W&I 保险理赔流程是怎样的？', a: '买方或卖方在发现保证违约后，需按保单约定及时通知保险公司并提交索赔材料；耀达可代表客户与保险人协调，推动调查、定损与赔付，保障交易价值不因索赔程序延误而受损。' },
    { q: '中小型并购交易适合购买 W&I 吗？', a: '视交易结构与谈判难点而定。金额较小但保证条款争议大、卖方无法提供长期赔偿保障的交易，W&I 同样能显著降低交割阻力；耀达可根据交易规模设计可负担的保单架构。' }
  ],
  cyberSecurity: [
    { q: '网络保险通常有哪些除外责任？', a: '常见除外包括已知漏洞未修复、内部人员故意行为、战争/基础设施中断等，具体因保单而异。购买前耀达可协助审阅除外条款，减少保障缺口。' },
    { q: '发生勒索软件攻击网络险能赔吗？', a: '多数网络保单在符合法律许可条件下，可覆盖勒索支付、谈判顾问费用及事件响应成本，但需满足保单约定的安全控制与通知要求。实际赔付以条款为准。' }
  ],
  propertyCasualty: [
    { q: '产品责任险和 CGL 有什么区别？', a: 'CGL（商业综合责任）覆盖企业经营场所及运营中对第三者的广泛责任；产品责任险更聚焦因产品缺陷导致的人身伤害或财产损失。制造、流通型企业通常两者均需配置。' },
    { q: '企业财产险保额如何确定？', a: '需按固定资产、存货、设备重置成本及业务中断影响综合评估，避免不足额投保导致比例赔付。耀达可协助盘点资产并设计匹配成长阶段的限额结构。' }
  ],
  employeeBenefits: [
    { q: '团体医疗险续保涨价怎么办？', a: '可通过分析赔付率、优化保障方案（如调整免赔额、门诊比例）、引入分层计划及市场比价来控制续保成本。耀达提供季度数据复盘支持年度方案迭代。' },
    { q: '初创公司适合配置哪些员工福利？', a: '早期企业可先配置基础团体医疗与意外保障，随团队扩张逐步增加重疾、人寿及弹性福利选项。耀达可按预算与人才策略分阶段设计。' }
  ],
  globalClients: [
    { q: '全球主保单（Master Policy）是什么？', a: '全球主保单由总部统筹，协调各国本地保单，确保跨国集团在多地获得一致或等效的保障框架，同时满足各驻地监管要求，便于集中管理与报告。' },
    { q: '供应链跨境风险如何用保险管理？', a: '可通过各国财产/责任本地保单，叠加供应链中断、货运及信用等相关保障，并明确关键节点责任划分。耀达协助梳理跨境供应链暴露并设计协调方案。' }
  ],
  privateEquity: [
    { q: 'GP 和 LP 在基金保险中谁是被保险人？', a: '取决于保单结构：基金 D&O 通常覆盖 GP、管理人及其董事高管；LP 是否纳入需看募资文件与保单定义。耀达可协助厘清各主体保障边界。' },
    { q: '基金退出阶段有什么特殊保险需求？', a: '退出/IPO 阶段面临招股书责任、业绩对赌及历史投资追溯等风险，需提前评估 D&O 限额是否充足，并考虑 W&I 或延长报告期安排。' }
  ],
  lifeScience: [
    { q: 'Biotech 临床前阶段需要什么保险？', a: '临床前企业可配置一般责任、财产、雇主相关保障及早期 D&O；进入临床后需增加临床试验责任险。耀达可按研发阶段逐步完善保障架构。' },
    { q: '医疗器械召回风险如何转移？', a: '可通过产品责任险及召回相关附加保障，覆盖通知、运输、销毁及品牌修复费用。出口企业还需关注目的地市场的本地产品责任要求。' }
  ],
  financialInstitutions: [
    { q: '银行保险机构如何满足监管对治理的要求？', a: '除完善内控外，董责险是常见的治理风险转移工具，可在董事高管面临监管调查或股东诉讼时提供辩护费用及个人责任保障。' },
    { q: '金融企业犯罪险保什么？', a: '犯罪险（Crime/Fidelity）通常覆盖员工欺诈、盗窃、伪造等内部犯罪导致的直接财务损失，与网络险、D&O 形成互补。' }
  ],
  realEstateConstructions: [
    { q: '工程履约保证保险能替代保证金吗？', a: '在符合政策与合同要求的前提下，履约保证保险可释放企业流动资金，替代传统现金或银行保函形式的履约保证金，降低资金占用。' },
    { q: '海外 EPC 项目保险怎么安排？', a: '需兼顾项目所在国工程险、第三者责任及跨境设备运输保障，并与国内总部保单协调。耀达可协助设计多国联动的工程保障架构。' }
  ],
  automotiveInfrastructure: [
    { q: '自动驾驶相关责任如何投保？', a: '涉及算法、传感器及 OTA 软件更新的责任归属仍在演进，需结合产品责任、网络及专业责任等组合方案，并与 OEM 及供应商合同中的责任分配一致。' },
    { q: 'UBI 保险对车队管理有什么价值？', a: '基于驾驶行为数据的 UBI 模式可实现更精准定价，激励安全驾驶并降低整体车队风险，耀达可协助对接支持 UBI 的保险方案。' }
  ],
  manufacturingTechnology: [
    { q: '制造企业如何应对关键设备停机损失？', a: '可通过商业财产险中的机器损坏及业务中断附加条款，覆盖关键设备故障导致的生产停滞损失，需明确等待期与赔偿期间。' },
    { q: '科技公司知识产权纠纷有保险吗？', a: '部分专业责任或媒体/知识产权相关附加保障可覆盖辩护费用及特定索赔，需逐案评估。耀达可协助识别 IP 暴露并匹配市场产品。' }
  ],
  foodBeverage: [
    { q: '预制菜/中央厨房有什么特殊风险？', a: '集中加工模式放大食安与供应链风险，需关注产品责任、召回、冷链中断及第三方物流责任，耀达可针对连锁与加工模式设计整合方案。' },
    { q: '出口食品企业需要什么保险？', a: '除国内产品责任外，需在进口国安排符合当地法规的责任保障，并考虑货运、信用及召回等跨境风险。' }
  ],
  energyPower: [
    { q: '风电/光伏项目运营期有什么风险？', a: '运营期需关注设备性能、天气波动、并网故障及营业中断，财产险与专门的技术/性能相关条款需与融资协议要求对齐。' },
    { q: '传统能源转型中的环境责任怎么保？', a: '可通过环境责任险覆盖污染清理、第三方索赔及监管处罚相关辩护费用，ESG 披露压力也提升了对 D&O 保障的需求。' }
  ],
  sportsEntertainmentEvents: [
    { q: '户外大型活动天气风险怎么保？', a: '活动取消/延期险可覆盖因极端天气等不可抗力导致的已发生费用及预期收入损失，需在活动前尽早投保并明确触发条件。' },
    { q: '赛事观众受伤责任谁承担？', a: '主办方公共/责任险可覆盖活动期间因组织管理疏忽导致观众或第三方人身伤害及财产损失的赔偿责任，限额需匹配活动规模。' }
  ]
}
